/**
 * Módulo que gerencia o estado das mensagens exibidas na aplicacao
 * @state Estados que devem ser controlados
 * @mutations Funções que tem permissão para alterar o state
 * @actions Executar operações asincronas e chamar mutations 
 * @getters Retorna o estado além da possibilidade de retornar a 
 * mesma lógica do computed (Gera valores com base em valores originais)
 */
import msalConfig from "../../config/msalConfig";
import { PublicClientApplication } from '@azure/msal-browser';

 const state = {
        msalConfig: msalConfig,
        accessToken: undefined
};



const mutations = {
     setAccessToken(state: any, token: any){
        state.accessToken = token;
      }
    

    }
    const getters = {
        getLoggedAccounts(){
            const $msalInstance = new PublicClientApplication(
                msalConfig
                
              );
                return $msalInstance.getAllAccounts();
            }
    }
    


export default {
    namespaced: true,
    state,
    getters,
    mutations
}